// src/validation/documentSchema.js
import Joi from 'joi';

export function getDocumentJoiSchema(doc) {
  const schemaObj = {};
  doc.fields.forEach(field => {
    if (field.type === 'text') {
      let validator = Joi.string().trim();
      // Aadhaar No. validation: 12 digits
      if (doc.key === 'aadhaar' && field.name === 'number') {
        validator = validator.pattern(/^[0-9]{12}$/).messages({
          'string.pattern.base': 'Aadhaar No. must be 12 digits',
        });
      }
      // Passport No. validation: removed - accept any format
      // Visa No. validation: removed - accept any format
      validator = field.required ? validator.required().messages({
        'string.empty': `${field.label} is required`,
        'any.required': `${field.label} is required`,
      }) : validator.allow('').optional();
      schemaObj[field.name] = validator;
    } else if (field.type === 'file') {
      schemaObj[field.name] = field.required ? Joi.object().required().messages({
        'any.required': `${field.label} is required`,
      }) : Joi.object().optional();
    } else if (field.type === 'date') {
      schemaObj[field.name] = field.required ? Joi.string().required().messages({
        'string.empty': `${field.label} is required`,
        'any.required': `${field.label} is required`,
      }) : Joi.string().allow('').optional();
    }
  });
  return Joi.object(schemaObj);
}
